// extracted by mini-css-extract-plugin
export var button = "Summary-module--button--801e9";
export var fadeInAnimation = "Summary-module--fadeInAnimation--25953";
export var open = "Summary-module--open--397f6";
export var summary = "Summary-module--summary--55209";
export var tags = "Summary-module--tags--25b8d";
export var text = "Summary-module--text--dd0f1";
export var title = "Summary-module--title--1cdb6";